const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/roles/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { Spinner } from '@tempo-io/sui-spinner';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { compactBooleanFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
import { isShowArchivedOn } from '@/features/settings/roles/isShowArchivedOn';
import { getSearchTeamRolesQueryOptions } from '@/features/settings/team-roles/queries/useTeamRolesQuery';
const roleSearchSchema = z.object({
  showArchived: compactBooleanFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/settings/roles/')({
  validateSearch: zodValidator(roleSearchSchema),
  loaderDeps: ({
    search
  }) => ({
    showArchived: search.showArchived
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    },
    deps
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getSearchTeamRolesQueryOptions('', {
      activeOnly: isShowArchivedOn(deps.showArchived) ? false : undefined
    }));
    return {
      crumb: i18n.t($ => $.common.settings.roles.label)
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.roles.label)
    }
  }
});